<div *ngIf="step === 1">
  <div class="mb-3 lato">Choose a location to start your request</div>
  <div
    *ngIf="newOpt && isNewOptUnique(newOpt.id)"
    class="input-container"
  >
    <span class="input-label">Searched Location</span>
    <div class="location-tile-list-container mt-2">
      <div class="location-tile-container">
        <app-location-tile
          [locationData]="newOpt"
          [isEditMode]="true"
          [isChangeMode]="true"
          [isSelected]="selectedLocation && newOpt.id === selectedLocation.id"
          (selectedChange)="changeSelectedLocationTile(newOpt)"
        ></app-location-tile>
      </div>
    </div>
  </div>
  <div class="input-container">
    <span class="input-label">Preferred Location</span>
    <div class="location-tile-list-container mt-2">
      <app-location-tile
        *ngFor="let location of locationList | slice:0:1"
        [locationData]="location"
        [isPreferred]="true"
        [isEditMode]="true"
        [isChangeMode]="true"
        [isSelected]="selectedLocation && location.id === selectedLocation.id"
        (selectedChange)="changeSelectedLocationTile(location)"
      ></app-location-tile>
    </div>
  </div>
  <div class="input-container">
    <span class="input-label">Other Visited Locations</span>
    <div class="location-tile-list-container mt-2">
      <span
        *ngIf="locationList?.length === 1"
        class="lato"
      >You have no other visited locations.</span>
      <div
        *ngFor="let location of locationList | slice:1"
        class="location-tile-container"
      >
        <app-location-tile
          *ngIf="location.id !== myProfileService.preferredLocation.id"
          [locationData]="location"
          [isEditMode]="true"
          [isChangeMode]="true"
          [isSelected]="selectedLocation && location.id === selectedLocation.id"
          (selectedChange)="changeSelectedLocationTile(location)"
        ></app-location-tile>
      </div>
    </div>
  </div>
  <div class="input-container">
    <app-arrow-link
      text="Choose a Different Location"
      (handleClick)="gotoStep2()"
    ></app-arrow-link>
  </div>
  <div style="margin-top: 2.5rem;">
    <hr>
    <footer class="footer-action">
      <button
        class="btn btn-danger btn-block"
        (click)="onSave()"
        [disabled]="!selectedLocation"
      >Continue</button>
    </footer>
  </div>
</div>
<div *ngIf="step === 2">
  <app-camp-location-search-select
    #searchSelect
    (selectedCampId)="handleSelectedCampId($event)"
  ></app-camp-location-search-select>
  <div>
    <hr>
    <footer class="flex-sm-row flex-column-reverse row no-gutters footer-action div-footer">
      <div class="col pr-sm-1">
        <button
          class="btn btn-outline-danger btn-block"
          (click)="step = 1"
        >Cancel</button>
      </div>
      <div class="col pl-sm-1">
        <button
          class="btn btn-danger btn-block mb-2 mb-sm-0"
          [ngClass]="{'disabled-btn': !isBtnEnabled}"
          (click)="onConfirmSelect()"
          [disabled]="!isBtnEnabled"
        >Select</button>
      </div>
    </footer>
  </div>
</div>
